import { AllTagsQuerySchema, AllTagsResponseSchema, EventsQuerySchema, EventsResponseSchema, HistoryQuerySchema, SiteAnchorHealthListResponseSchema, SiteOverviewListResponseSchema, SiteTagFleetListResponseSchema, SiteTagFleetTagsListQuerySchema, SiteTagFleetTagsListResponseSchema, TagCurrentStateListResponseSchema, TagHistoryResponseSchema, TenantIntegrationStatusResponseSchema, TenantSiteAnchorHealthListQuerySchema, TenantSiteTagFleetListQuerySchema, TenantSiteTagFleetSiteParamsSchema, UwbCommandRequestSchema, UwbCommandResponseSchema, UwbSiteParamsSchema, UwbTagParamsSchema, } from '../../schemas.js';
const locationBase = { base: 'location' };
/** REST contract for `spatial-service/src/routes/location/uwb-location.routes.ts` (tenant). */
export const locationUwbContract = {
    getTagsCurrent: {
        method: 'GET',
        path: '/location/sites/:siteId/tags/current',
        pathParams: UwbSiteParamsSchema,
        response: TagCurrentStateListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get current tag states',
        ...locationBase,
    },
    getIntegrationStatus: {
        method: 'GET',
        path: '/location/sites/:siteId/integration-status',
        pathParams: UwbSiteParamsSchema,
        response: TenantIntegrationStatusResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get location integration status',
        ...locationBase,
    },
    getAnchorsCurrent: {
        method: 'GET',
        path: '/location/sites/:siteId/anchors/current',
        pathParams: UwbSiteParamsSchema,
        response: TagCurrentStateListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get current anchor states',
        ...locationBase,
    },
    getTagHistory: {
        method: 'GET',
        path: '/location/sites/:siteId/tags/:serialNumber/history',
        pathParams: UwbTagParamsSchema,
        query: HistoryQuerySchema,
        response: TagHistoryResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get tag history',
        ...locationBase,
    },
    getSiteEvents: {
        method: 'GET',
        path: '/location/sites/:siteId/events',
        pathParams: UwbSiteParamsSchema,
        query: EventsQuerySchema,
        response: EventsResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to get site events',
        ...locationBase,
    },
    sendCommand: {
        method: 'POST',
        path: '/location/sites/:siteId/commands',
        pathParams: UwbSiteParamsSchema,
        body: UwbCommandRequestSchema,
        response: UwbCommandResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to send UWB command',
        ...locationBase,
    },
    listSites: {
        method: 'GET',
        path: '/location/sites',
        response: SiteOverviewListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to list location sites',
        ...locationBase,
    },
    listAllTags: {
        method: 'GET',
        path: '/location/tags',
        query: AllTagsQuerySchema,
        response: AllTagsResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to list location tags',
        ...locationBase,
    },
    listSiteTagFleet: {
        method: 'GET',
        path: '/location/site-tag-fleet',
        query: TenantSiteTagFleetListQuerySchema,
        response: SiteTagFleetListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to list site tag fleet',
        ...locationBase,
    },
    listSiteTagFleetTags: {
        method: 'GET',
        path: '/location/site-tag-fleet/:siteId/tags',
        pathParams: TenantSiteTagFleetSiteParamsSchema,
        query: SiteTagFleetTagsListQuerySchema,
        response: SiteTagFleetTagsListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to list site tag fleet tags',
        ...locationBase,
    },
    listSiteAnchorHealth: {
        method: 'GET',
        path: '/location/site-anchor-health',
        query: TenantSiteAnchorHealthListQuerySchema,
        response: SiteAnchorHealthListResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to list site anchor health',
        ...locationBase,
    },
};
//# sourceMappingURL=location-uwb.contract.js.map